import React from 'react';
import PropTypes from 'prop-types';
import styles from './style.css';

class NPWPDetail extends React.Component {
  render() {
    const { business, identity, isOwner, onClickUpdateNpwpInfo } = this.props;
    let NPWPImage;
    if (identity.NPWP_IMAGE_URL) {
      NPWPImage = (
        <img
          src={identity.NPWP_IMAGE_URL}
          className={styles['img-preview']}
          alt=""
        />
      );
    } else {
      NPWPImage = <div>-</div>;
    }
    let verifiedStatus;
    switch (business.npwpStatus) {
      case 'rejected':
        verifiedStatus = (
          <span className={`${styles['ml-10']} ${styles.rejected}`}>
            <i className="fa fa-info-circle" /> Rejected
          </span>
        );
        break;
      case 'pending':
        verifiedStatus = (
          <span className={`${styles['ml-10']} ${styles.unverified}`}>
            <i className="fa fa-info-circle" /> Waiting for approval
          </span>
        );
        break;
      case 'approved':
        verifiedStatus = (
          <span className={`${styles['ml-10']} ${styles.verified}`}>
            <i className="fa fa-check-circle" /> Approved
          </span>
        );
        break;
      default:
        verifiedStatus = null;
    }
    return (
      <div className={`row ${styles['pt-25']}`}>
        <div className="col-xs-12">
          <div className={styles['mk-section-header']}>
            NPWP (Optional) {verifiedStatus}
            {isOwner && verifiedStatus === null && (
              <button
                className="btn btn-link pull-right"
                onClick={onClickUpdateNpwpInfo}
              >
                Edit
              </button>
            )}
          </div>
        </div>
        <div className="col-xs-12">
          <div className={styles['text-label']}>
            NPWP Name
            <div className={`pull-right ${styles['text-description']}`}>
              {identity.NPWP_NAME}
            </div>
          </div>
          <div className={styles['mk-divider-section-line']} />
        </div>
        <div className="col-xs-12">
          <div className={`${styles['text-label']} ${styles['image-block']}`}>
            NPWP Photo
            <div className={`pull-right ${styles['text-description']}`}>
              {NPWPImage}
            </div>
          </div>
          <div className={styles['mk-divider-section-line']} />
        </div>
        <div className="col-xs-12">
          <div className={styles['text-label']}>
            NPWP Number
            <div className={`pull-right ${styles['text-description']}`}>
              {identity.NPWP_NUMBER}
            </div>
          </div>
          <div className={styles['mk-divider-section-line']} />
        </div>
      </div>
    );
  }
}

NPWPDetail.propTypes = {
  identity: PropTypes.object,
  business: PropTypes.object,
};

export default NPWPDetail;
